module.exports = __webpack_public_path__ + "static/media/s7logo_crop.7bfff79a.png";